/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Object } from '../../models/object';
import { SearchCenterTransactionResponseDto } from '../../models/search-center-transaction-response-dto';

export interface CenterTransactionControllerSearch$Params {
  centerId: string;

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 선생님 ID
 */
  centerUserId?: string;

/**
 * 사용자 ID
 */
  division?: Object;

/**
 * 시작일
 */
  startDate?: string;

/**
 * 종료일
 */
  endDate?: string;

/**
 * 결제 수단
 */
  paymentMethods?: Array<string>;

/**
 * 유형
 */
  types?: Array<'\uD68C\uAE30' | '\uD658\uBD88' | '\uD68C\uAE30 \uC678' | '\uAE09\uC5EC' | '\uC9C1\uC811\uC785\uB825'>;
}

export function centerTransactionControllerSearch(http: HttpClient, rootUrl: string, params: CenterTransactionControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchCenterTransactionResponseDto>> {
  const rb = new RequestBuilder(rootUrl, centerTransactionControllerSearch.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('centerUserId', params.centerUserId, {});
    rb.query('division', params.division, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('paymentMethods', params.paymentMethods, {});
    rb.query('types', params.types, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchCenterTransactionResponseDto>;
    })
  );
}

centerTransactionControllerSearch.PATH = '/api/center-transaction';
